import {reactive} from 'petite-vue'

const submitBtn = document.querySelector('.submit-chat-btn');
const form = document.querySelector('#chat-form');
const parentDiv = document.querySelector('#chat');

export default function ChatForm() {
  
  return {
    loading: reactive(false),
    data: {},
    show: false,
    lastTime: 0,
    async submitForm(e) {
      if (new Date() - this.lastTime < 1000) return;
      this.lastTime = new Date();

      const formData = new FormData(e.target);

      this.loading = true;
      const myHeaders = new Headers();
      try {
        const res = await fetch('/services/post/', {
          method: 'POST',
          headers: myHeaders,
          body: formData,
          redirect: 'follow'
        });
        const data = await res.json();
        // submitBtn.disabled = true;

        this.loading = false;
        this.data = {...data, done: true};
        e.target.reset();
        
      }
      catch (error) {
        this.loading = false;
        console.log('error', error);
      }
    },
    handleChat() {
      if ([...form.classList].includes('hidden')) {
        this.showChat();
      } else {
        this.hideChat();
      }
    },
    showChat() {
      form.classList.remove('hidden');
      setTimeout(() => {
        form.classList.remove('invisible');
        form.classList.remove('opacity-0');
        form.classList.remove('opacity-1');
      }, 250);
    },
    hideChat() {
      form.classList.add('invisible');
      form.classList.add('opacity-0');
      form.classList.add('opacity-1');
      setTimeout(() => {
        form.classList.add('hidden');
      }, 250);

    },
    handleClick() {
      const listener = (event) => {
        if (!parentDiv.contains(event.target)) {
          this.hideChat();
        }
      };
      document.addEventListener("click", listener);

      return () => document.removeEventListener(listener);
    }
  }
}


// curl -X POST -H 'Content-type: application/json' --data '{"text":"Hello, World!"}' https://hooks.slack.com/services/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